import { render, staticRenderFns } from "./Include.vue?vue&type=template&id=481c0cf6&scoped=true"
import script from "./Include.vue?vue&type=script&lang=js"
export * from "./Include.vue?vue&type=script&lang=js"
import style0 from "./Include.vue?vue&type=style&index=0&id=481c0cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c0cf6",
  null
  
)

export default component.exports